/* ============
 * Order Transformer
 * ============
 *
 * The transformer for the order.
 */

import type { ExternalOrder, IntegrationOrder } from '@/types/Models/Integration'

export default class IntegrationOrderTransformer {
  /**
   * Method used to transform a fetched item.
   */
  static fetch(item: IntegrationOrder): ExternalOrder {
    return {
      externalId: item.external_identifier,
      internalId: item.internal_identifier || '',
      status: item.import_status,
      error: item.error,
      id: item?.id || '',
      reference: item.label_data?.reference || null,
    }
  }

  /**
   * Method used to transform a fetched collection.
   */
  static fetchCollection(items: IntegrationOrder[]) {
    return items.map((item) => this.fetch(item))
  }
}
